import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const commonUpload = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.AppService}common/upload`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};